import styled from "@emotion/styled";
import { CircularProgress, css } from "@mui/material";
import { myTheme } from "styles/theme";

const borderColor = myTheme.palette.layout.line;

// table body
export const cellCommonStyle = css`
  font-size: 12px;
  color: #2d2d2d;
  position: relative;
  padding: 4px 14px;
  border: 1px solid ${borderColor};
  max-width: 320px;
  white-space: pre;

  > * {
    font-size: inherit;
    line-height: inherit;
  }
`;

export const TableStyle = css`
  position: relative;
  background: #fff;
  font-size: 12px;
  text-align: center;
  border-collapse: collapse;
  overflow: auto;
  color: #2d2d2d;
  thead {
    border-bottom: 1px solid ${borderColor};
  }
`;

export const TbodyDefaultStyle = css`
  td {
    border: 1px solid #dee2ec;
  }
`;

export const TbodyStyle = css`
  td {
    padding: 4px 14px;
    border-right: 1px solid;
    border-color: ${borderColor};
    white-space: pre;
    min-width: 25px;
    font-size: 12px;

    &:last-child {
      border-right: 0;
    }
  }
`;

export const TdStyle = css`
  position: relative;
  border: 1px solid ${borderColor};
  max-width: 320px;
  white-space: pre;
  padding: 4px 14px;
  > * {
    font-size: inherit;
    line-height: inherit;
  }
`;

export const ColumnValue = styled.div`
  display: inline-block;
  text-align: inherit;
  text-decoration: inherit;
  vertical-align: middle;
  min-height: 12px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const createThStyle = ({
  $grow,
  $resizable,
  styleType,
}: {
  $grow?: boolean;
  $resizable?: boolean;
  styleType?: "chart" | "statistics";
}) => css`
  ${cellCommonStyle}
  position: relative;
  font-weight: 700;
  word-break: keep-all;
  height: 32px;

  ${$grow
    ? `
        width: auto;
      `
    : `
        ${!$resizable && "width: 1%"};
        white-space: pre;
        min-width: 25px;
      `}

  ${(styleType === "chart" || styleType === "statistics") &&
  `
      line-height: 1.2;
      padding: 6px;
      border: none;
      position: sticky;
      top: 0;
      z-index: 1;
      background: #fff;

      button[name='sort'] {
        margin-left: 8px;
        padding: 0;
      }
    `}
`;

export const ThCell = styled.span`
  display: inline-block;
`;

export const LoadingIcon = styled(CircularProgress)`
  color: #2c62f6;
`;
